var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3004 12.0605L0 5.81367L2.40323 3.43086L6.3004 7.29492L13.5968 0.0605469L16 2.44336L6.3004 12.0605Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconDisabled);
export default __webpack_public_path__ + "static/media/tickIconDisabled.d98de6c718fb4d7bd4ef468fe453943a.svg";
export { ForwardRef as ReactComponent };